import { getCurrentBreakpoint } from "@voix/composables/useBreakpoints";
import { useBreakpointStore } from "@voix/store/breakpointStore";
export default (voix, nuxtPinia) => {
  const breakpointStore = useBreakpointStore(nuxtPinia);
  if (typeof window === "undefined") {
    voix.breakpoint.value = "default";
  } else {
    voix.breakpoint.value = getCurrentBreakpoint(window.innerWidth).name;
    window.addEventListener("resize", () => {
      voix.breakpoint.value = getCurrentBreakpoint(window.innerWidth).name;
    });
  }
  const breakpointTests = function(breakpointIdentifier, operator) {
    const breakpoints = breakpointStore.breakpoints;
    const testingBreakpoint = breakpoints.find((bp) => bp.name === voix.breakpoint.value);
    const testingAgainstBreakpoint = breakpoints.find((bp) => bp.name === breakpointIdentifier);
    const operators = {
      "<": (a, b) => a < b,
      ">": (a, b) => a > b,
      "<=": (a, b) => a <= b,
      ">=": (a, b) => a >= b
    };
    if (testingBreakpoint && testingAgainstBreakpoint)
      return operators[operator](breakpoints.indexOf(testingBreakpoint), breakpoints.indexOf(testingAgainstBreakpoint));
    return false;
  };
  Object.defineProperty(voix.breakpoint, "isLessThan", {
    value: (breakpointIdentifier, width) => {
      if (typeof width !== "undefined") {
        voix.breakpoint.value = getCurrentBreakpoint(width).name;
      }
      return breakpointTests(breakpointIdentifier, "<");
    }
  });
  Object.defineProperty(voix.breakpoint, "isLessThanInclusive", {
    value: (breakpointIdentifier, width) => {
      if (typeof width !== "undefined") {
        voix.breakpoint.value = getCurrentBreakpoint(width).name;
      }
      return breakpointTests(breakpointIdentifier, "<=");
    }
  });
  Object.defineProperty(voix.breakpoint, "isGreaterThan", {
    value: (breakpointIdentifier, width) => {
      if (typeof width !== "undefined") {
        voix.breakpoint.value = getCurrentBreakpoint(width).name;
      }
      return breakpointTests(breakpointIdentifier, ">");
    }
  });
  Object.defineProperty(voix.breakpoint, "isGreaterThanInclusive", {
    value: (breakpointIdentifier, width) => {
      if (typeof width !== "undefined") {
        voix.breakpoint.value = getCurrentBreakpoint(width).name;
      }
      return breakpointTests(breakpointIdentifier, ">=");
    }
  });
  Object.defineProperty(voix.breakpoint, "isBetween", {
    value: (breakpointIdentifierMin, breakpointIdentifierMax, width) => {
      if (typeof width !== "undefined") {
        voix.breakpoint.value = getCurrentBreakpoint(width).name;
      }
      return breakpointTests(breakpointIdentifierMin, ">") && breakpointTests(breakpointIdentifierMax, "<");
    }
  });
  Object.defineProperty(voix.breakpoint, "isBetweenInclusive", {
    value: (breakpointIdentifierMin, breakpointIdentifierMax, width) => {
      if (typeof width !== "undefined") {
        voix.breakpoint.value = getCurrentBreakpoint(width).name;
      }
      return breakpointTests(breakpointIdentifierMin, ">=") && breakpointTests(breakpointIdentifierMax, "<=");
    }
  });
  return voix;
};
